import { MoveableOverlay } from "./MoveableOverlay";

export class MoveableOverlayText extends MoveableOverlay {

	type: string = "text";

	value: string;
	style: any;

	isRectangle: boolean;

	constructor(variationId: string, twinnedId: string) {
		super(variationId, twinnedId);

		this.value = "";
		this.style = {
			paragraph: "center",
			color: '#000000',
			fontWeight: 'normal',
			fontStyle: 'normal', //'italic'
			isUnderline: false,
			font: { name: "Roboto, sans-serif", title: "Roboto" },
			size: { name: "25px", title: "25 px", value: 25 },
			height: { name: "30px", title: "30 px", value: 30 },
			outline: { show: false, color: '#ffffff', size: { name: "1px", title: "1 px", value: 1 } },
			box: { show: true, color: '#ffffff', width: 0 },
			opacity: 1
		};

		this.isRectangle = false;

		this.position = 'center-top';
		this.moveableObject = {
			draggable: true,
			throttleDrag: 0,
			resizable: false,
			throttleResize: 1,
			keepRatio: true,
			scalable: true,
			throttleScale: 1,
			rotatable: true,
			throttleRotate: 0,
			pinchable: true, // ["draggable", "resizable", "scalable", "rotatable"]
			origin: false,
			padding: { left: 5, top: 5, right: 5, bottom: 5 },
			snappable: true,
			snapVertical: true,
			snapHorizontal: true,
			snapElement: true,
			snapThreshold: 0,
			snapCenter: true,
		};
		this.moveabaleStyle = {
			//width: "100%",
			//height: "30%",
			left: "unset",
			top: "5%",
			//right: 0,
			//bottom: 0,
			position: "absolute",
			userSelect: "none"
		};
	}

	copyProperties(overlayToCopy: MoveableOverlayText) {
		super.copyProperties(overlayToCopy);

		this.value = JSON.parse(JSON.stringify(overlayToCopy.value));
		this.style = JSON.parse(JSON.stringify(overlayToCopy.style));
		if (!this.style.paragraph) {
			this.style.paragraph = "center";
		}
		if (this.style.isUnderline === undefined) {
			this.style.isUnderline = false;
		}
		if (this.style.fontStyle === undefined) {
			this.style.fontStyle = 'normal';
		}
		if (this.style.box.width === undefined) {
			this.style.box.width = 0;
		}

		this.isRectangle = !!overlayToCopy.isRectangle;
	}

	copy(): MoveableOverlayText {
		let copy = new MoveableOverlayText(this.variationId, this.twinnedId);

		copy.copyProperties(this);
		return copy;
	}

	static copyFromParsed(parsedObject: any): MoveableOverlayText {
		let copy = new MoveableOverlayText(parsedObject.variationId, parsedObject.twinnedId ? parsedObject.twinnedId : null);

		copy.copyProperties(parsedObject);
		return copy;
	}
	updateTextBoxCanvas(cv, text, currentTextValue) {
		if (text.value === "") {
			cv.height = text.offsetDimensions.height;
			cv.width = text.offsetDimensions.width;
			cv.getContext('2d').clearRect(0, 0, text.offsetDimensions.width, text.offsetDimensions.height);
			return;
		}
		cv.getContext('2d').imageSmoothingEnabled = true;
		let k = 4;//upscale

		let width = text.offsetDimensions.width * k;
		let height = text.offsetDimensions.height * k;

		let lineHeight = text.style.height.value;
		let textHeight = text.style.size.value;

		let isTransparent = true;
		let foregroundColor = text.style.color;
		let outlineColor = text.style.outline.color;
		let backgroundColor = 'none';
		let showOutline = text.style.outline.show;
		let outlineSize = text.style.outline.size.value;
		let font = text.style.font.title;
		let fontWeight = text.style.fontWeight;
		let fontStyle = text.style.fontStyle;
		let opacity = text.style.opacity;
		let textValue = currentTextValue !== undefined && currentTextValue !== null ? currentTextValue : text.value;
		let textRows = textValue
			.replace(/\r\n/g, "\n")
			.split("\n");//text.valueLines;

		//TODO это костыль. Пока хз как сделать иначе
		if (textRows[textRows.length - 1] === "") {
			textRows.splice(-1, 1);
		}

		let boxWidth = text.style.box.width * k /* * text.transforms.scaleX */;

		let finalTextHeight = textHeight * k /* * text.transforms.scaleX */;
		let finalRowHeight = lineHeight * k /* * text.transforms.scaleX */;
		height = finalRowHeight * textRows.length;

		cv.height = height + 2 * boxWidth;
		cv.width = width;
		let ctx = cv.getContext('2d');
		ctx.clearRect(0, 0, width, height);
		ctx.font = fontStyle + " " + fontWeight + " " + finalTextHeight + 'px "' + font + '"';
		if (isTransparent) {
			ctx.clearRect(0, 0, width, height);
		} else {
			ctx.fillStyle = backgroundColor;
			ctx.fillRect(0, 0, width, height);
		}
		ctx.fillStyle = foregroundColor;
		ctx.textAlign = text.style.paragraph;//'center';
		ctx.textBaseline = 'middle';//baseline;

		ctx.shadowColor = outlineColor;
		ctx.shadowBlur = 0;
		ctx.lineWidth = outlineSize;
		let padding = 10 * k /* * text.transforms.scaleX */;
		ctx.translate(ctx.textAlign === "left"
			? boxWidth + padding
			: ctx.textAlign === "center"
				? width / 2
				: width - padding - boxWidth,
			boxWidth + finalRowHeight / 2);
		if (showOutline) {
			ctx.strokeStyle = outlineColor;
			ctx.strokeText(textValue, 0, 0);
		}
		ctx.shadowBlur = 0;
		ctx.fillStyle = foregroundColor;
		//ctx.fillText(textValue, 0, 0);

		let y = 0;
		textRows.forEach((row, i) => {
			ctx.fillStyle = text.style.box.color;
			let rowWidth = ctx.measureText(row).width;
			let def = 0.5;
			ctx.globalAlpha = opacity;
			let rectX = ctx.textAlign === "left"
				? - padding
				: ctx.textAlign === "center"
					? -rowWidth / 2 - padding
					: -rowWidth - padding;
			let rectY = y - finalRowHeight / 2 - def;

			let roundWidth = 4 * k /* * text.transforms.scaleX */;
			let prevRowWidth = i != 0 ? ctx.measureText(textRows[i - 1]).width : null;
			let nextRowWidth = i !== textRows.length - 1 ? ctx.measureText(textRows[i + 1]).width : null;

			let boxCorners = this.getTextLineBoxCorners(textRows, i, rowWidth, prevRowWidth, nextRowWidth, ctx.textAlign, roundWidth);

			this.textRectBox(ctx,
				rectX - boxWidth,
				rectY - boxWidth,
				ctx.measureText(row).width + 2 * padding + 2 * boxWidth,
				finalRowHeight + 2 * def + 2 * boxWidth,
				4 * k,
				true,
				false,
				boxCorners);

			y += finalRowHeight;
		});

		return cv.toDataURL('image/png');
	}

	getTextLineBoxCorners(textRows, i, rowWidth, prevRowWidth, nextRowWidth, textAlign, roundWidth) {
		let boxCorners = { topL: "", topR: "", downL: "", downR: "" };

		if (i === 0) {
			//первая строка
			//ВЕРХ всегда скругленный
			boxCorners.topL = "in";
			boxCorners.topR = "in";

			if (i === textRows.length - 1) {
				//Если первая и последняя
				boxCorners.downL = "in";
				boxCorners.downR = "in";
			} else {
				let nextRowWidthDif = (rowWidth - nextRowWidth) / (textAlign === "center" ? 2 : 1);

				if (nextRowWidthDif >= roundWidth) {
					//Если следующая строка меньше чем на D, то НИЗ внутрь
					boxCorners.downL = "in";
					boxCorners.downR = "in";
				} else if (nextRowWidthDif <= -roundWidth) {
					//Если больше, то наружу
					boxCorners.downL = "out";
					boxCorners.downR = "out";
				} else {
					//Если также, то прямо
					boxCorners.downL = "flat";
					boxCorners.downR = "flat";
				}

				if (textAlign === "left") {
					boxCorners.downL = "flat";
				} else if (textAlign === "right") {
					boxCorners.downR = "flat";
				}
			}

		} else if (i === textRows.length - 1) {
			//последняя строка
			//НИЗ всегда скругленный
			boxCorners.downL = "in";
			boxCorners.downR = "in";

			let prevRowWidthDif = (rowWidth - prevRowWidth) / (textAlign === "center" ? 2 : 1);

			if (prevRowWidthDif >= roundWidth) {
				//Если предыдущая строка меньше чем на D, то ВЕРХ внутрь
				boxCorners.topL = "in";
				boxCorners.topR = "in";
			} else if (prevRowWidthDif <= -roundWidth) {
				//Если больше, то наружу
				boxCorners.topL = "out";
				boxCorners.topR = "out";
			} else {
				//Если также, то прямо
				boxCorners.topL = "flat";
				boxCorners.topR = "flat";
			}

			if (textAlign === "left") {
				boxCorners.topL = "flat";
			} else if (textAlign === "right") {
				boxCorners.topR = "flat";
			}
		} else {
			//middle
			let prevRowWidthDif = (rowWidth - prevRowWidth) / (textAlign === "center" ? 2 : 1);
			let nextRowWidthDif = (rowWidth - nextRowWidth) / (textAlign === "center" ? 2 : 1);

			if (prevRowWidthDif >= roundWidth) {
				//Если предыдущая строка меньше чем на D, то ВЕРХ внутрь
				boxCorners.topL = "in";
				boxCorners.topR = "in";
			} else if (prevRowWidthDif <= -roundWidth) {
				//Если больше, то наружу
				boxCorners.topL = "out";
				boxCorners.topR = "out";
			} else {
				//Если также, то прямо
				boxCorners.topL = "flat";
				boxCorners.topR = "flat";
			}
			if (nextRowWidthDif >= roundWidth) {
				//Если следующая строка меньше чем на D, то НИЗ внутрь
				boxCorners.downL = "in";
				boxCorners.downR = "in";
			} else if (nextRowWidthDif <= -roundWidth) {
				//Если больше, то наружу
				boxCorners.downL = "out";
				boxCorners.downR = "out";
			} else {
				//Если также, то прямо
				boxCorners.downL = "flat";
				boxCorners.downR = "flat";
			}

			if (textAlign === "left") {
				boxCorners.topL = "flat";
				boxCorners.downL = "flat";
			} else if (textAlign === "right") {
				boxCorners.topR = "flat";
				boxCorners.downR = "flat";
			}
		}
		return boxCorners;
	}

	getTextRows(textOverlay, canvas: HTMLCanvasElement, padding) {
		let textRows = [];
		if (!textOverlay.isRectangle) {
			textRows = textOverlay.value
				.replace(/\r\n/g, "\n")
				.split("\n");
		} else {
			let ctx = canvas.getContext('2d');
			let currentRow = "";

			textOverlay.value.split('').forEach((symbol, i) => {
				if (symbol === '\n') {
					textRows.push(currentRow);
					currentRow = "";
					return;
				} /* else if (symbol === ' ' || symbol === '-') {
					//TODO it maybe on one line
					textRows.push(currentRow + symbol);
					currentRow = "";
					return;
				} */
				let rowWidth = ctx.measureText(currentRow + symbol).width;
				if (rowWidth <= canvas.width - 2 * padding) {
					currentRow += symbol;
					if (i === textOverlay.value.length - 1) {
						textRows.push(currentRow);
					}
				} else {
					textRows.push(currentRow);
					currentRow = symbol;
				}
			});

		}
		return textRows;
	}

	getTextImage(videoPreviewPixelsWidth, outerVideoResolutionX, videoScale, currentSize) {
		let text = this;
		if (text.value === "") {
			return {
				image: "",
				x: 0,
				y: 0,
				w: 0,
				h: 0
			};
		}

		let upscale = 1;
		let upscalePadding = 10;
		let outerVideoWidth = outerVideoResolutionX;
		let p = outerVideoWidth / videoPreviewPixelsWidth;
		let k = p * videoScale * upscale;

		let overlayCenterXY = this.getOverlayCenterXY(videoPreviewPixelsWidth, currentSize);
		let tx = overlayCenterXY.x * k;
		let ty = overlayCenterXY.y * k;
		let width = this.offsetDimensions.width * k * this.transforms.scaleX + 2 * upscalePadding;
		let height = this.offsetDimensions.height * k * this.transforms.scaleX/* + 2 * upscalePadding */;

		let lineHeight = text.style.height.value;
		let textHeight = text.style.size.value;

		let isTransparent = true;
		let foregroundColor = text.style.color;
		let outlineColor = text.style.outline.color;
		let backgroundColor = text.isRectangle ? text.style.box.color : 'none';
		let showOutline = text.style.outline.show;
		let outlineSize = text.style.outline.size.value;
		let font = text.style.font.title;
		let fontWeight = text.style.fontWeight;
		let fontStyle = text.style.fontStyle;
		let opacity = text.style.opacity;
		let textValue = text.value;
		/* 		let textRows = textValue
					.replace(/\r\n/g, "\n")
					.split("\n");//text.valueLines; */
		//let textRows = this.getTextRows(text, cv);
		let boxWidth = text.style.box.width * k * text.transforms.scaleX;

		let finalTextHeight = textHeight * k * text.transforms.scaleX;
		let finalRowHeight = lineHeight * k * text.transforms.scaleX;
		//height = finalRowHeight * textRows.length + 2 * boxWidth  /* + 2 * upscalePadding */;

		const cv = <HTMLCanvasElement>document.createElement("CANVAS");
		cv.height = height;
		cv.width = width;
		let ctx = cv.getContext('2d');
		ctx.clearRect(0, 0, width, height);
		ctx.font = fontStyle + " " + fontWeight + " " + finalTextHeight + 'px "' + font + '"';
		if (isTransparent && !text.isRectangle) {
			ctx.clearRect(0, 0, width, height);
		} else {
			ctx.globalAlpha = opacity;
			ctx.fillStyle = backgroundColor;
			ctx.fillRect(0, 0, width, height);
		}
		ctx.fillStyle = foregroundColor;
		ctx.textAlign = text.style.paragraph;//'center';
		ctx.textBaseline = 'middle';//baseline;

		ctx.shadowColor = outlineColor;
		ctx.shadowBlur = 0;
		ctx.lineWidth = outlineSize;
		let padding = 10 * k * text.transforms.scaleX;
		ctx.translate(ctx.textAlign === "left"
			? boxWidth + padding
			: ctx.textAlign === "center"
				? width / 2
				: width - padding - boxWidth,
			boxWidth + finalRowHeight / 2 /* + upscalePadding */);
		if (showOutline) {
			ctx.strokeStyle = outlineColor;
			ctx.strokeText(textValue, 0, 0);
		}
		ctx.shadowBlur = 0;
		ctx.fillStyle = foregroundColor;
		//ctx.fillText(textValue, 0, 0);

		let textRows = this.getTextRows(text, cv, padding + upscalePadding);
		let calcHeight = finalRowHeight * textRows.length;
		let topPadding = (height - calcHeight) / 2 - boxWidth;
		let y = text.isRectangle ? topPadding : 0;
		textRows.forEach((row, i) => {
			ctx.fillStyle = text.style.box.color;
			let rowWidth = ctx.measureText(row).width;
			let def = 0.5;
			ctx.globalAlpha = opacity;
			let rectX = ctx.textAlign === "left"
				? - padding
				: ctx.textAlign === "center"
					? -rowWidth / 2 - padding
					: -rowWidth - padding;
			let rectY = y - finalRowHeight / 2 - def;

			let roundWidth = 4 * k * text.transforms.scaleX;
			let prevRowWidth = i != 0 ? ctx.measureText(textRows[i - 1]).width : null;
			let nextRowWidth = i !== textRows.length - 1 ? ctx.measureText(textRows[i + 1]).width : null;

			let boxCorners = this.getTextLineBoxCorners(textRows, i, rowWidth, prevRowWidth, nextRowWidth, ctx.textAlign, roundWidth);

			if (!text.isRectangle) {
				this.textRectBox(ctx,
					rectX - boxWidth,
					rectY - boxWidth,
					ctx.measureText(row).width + 2 * padding + 2 * boxWidth,
					finalRowHeight + 2 * def + 2 * boxWidth,
					4 * k * text.transforms.scaleX,
					true,
					false,
					boxCorners);
			}

			ctx.globalAlpha = 1.0;
			ctx.fillStyle = foregroundColor;
			let edgeIndent = (finalRowHeight - finalTextHeight) / 2;
			ctx.fillText(row, 0, y + edgeIndent);
			if (text.style.isUnderline) {
				//this.drawTextUnderline(ctx, text, 0, y - edgeIndent);
				this.textUnderline(ctx, row, 0, y - edgeIndent + finalTextHeight / 2, foregroundColor, finalTextHeight, ctx.textAlign);
			}
			y += finalRowHeight;
		});

		if (boxWidth !== 0 && !text.isRectangle) {
			y = 0;
			textRows.forEach(row => {
				ctx.globalAlpha = 1.0;
				ctx.fillStyle = foregroundColor;
				let edgeIndent = (finalRowHeight - finalTextHeight) / 2;
				ctx.fillText(row, 0, y + edgeIndent);
				if (text.style.isUnderline) {
					//this.drawTextUnderline(ctx, text, 0, y - edgeIndent);
					this.textUnderline(ctx, row, 0, y - edgeIndent + finalTextHeight / 2, foregroundColor, finalTextHeight, ctx.textAlign);
				}
				y += finalRowHeight;
			});
		}

		/* ctx.save();
		ctx.translate(width / 2, height / 2);
		//ctx.rotate(this.angle * Math.PI / 180);
		ctx.fillText(textValue, 0, 0);
		ctx.restore(); */
		//this.download(cv)

		return {
			image: cv.toDataURL('image/png'),
			x: tx / upscale,
			y: ty / upscale,
			w: (width - 2 * upscalePadding) / upscale,
			h: (height /* - 2 * upscalePadding */) / upscale
		};
	}

	textRectBox(ctx, x, y, width, height, radius, fill, stroke, boxCornersType) {
		if (typeof stroke == 'undefined') {
			stroke = true;
		}
		if (typeof radius === 'undefined') {
			radius = 5;
		}
		if (typeof radius === 'number') {
			radius = { tl: radius, tr: radius, br: radius, bl: radius };
		} else {
			var defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
			for (var side in defaultRadius) {
				radius[side] = radius[side] || defaultRadius[side];
			}
		}
		ctx.beginPath();

		switch (boxCornersType.topL) {
			case "in":
				ctx.moveTo(x + radius.tl, y);
				break;
			case "out":
				ctx.moveTo(x - radius.tl, y);
				break;
			case "flat":
				ctx.moveTo(x, y);
				break;
			default:
				break;
		}

		switch (boxCornersType.topR) {
			case "in":
				ctx.lineTo(x + width - radius.tr, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
				break;
			case "out":
				ctx.lineTo(x + width + radius.tr, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
				break;
			case "flat":
				ctx.lineTo(x + width, y);
				break;
			default:
				break;
		}

		switch (boxCornersType.downR) {
			case "in":
				ctx.lineTo(x + width, y + height - radius.br);
				ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
				break;
			case "out":
				ctx.lineTo(x + width, y + height - radius.br);
				ctx.quadraticCurveTo(x + width, y + height, x + width + radius.br, y + height);
				break;
			case "flat":
				ctx.lineTo(x + width, y + height);
				break;
			default:
				break;
		}

		switch (boxCornersType.downL) {
			case "in":
				ctx.lineTo(x + radius.bl, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
				break;
			case "out":
				ctx.lineTo(x - radius.bl, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
				break;
			case "flat":
				ctx.lineTo(x, y + height);
				break;
			default:
				break;
		}

		switch (boxCornersType.topL) {
			case "in":
				ctx.lineTo(x, y + radius.tl);
				ctx.quadraticCurveTo(x, y, x + radius.tl, y);
				break;
			case "out":
				ctx.lineTo(x, y + radius.tl);
				ctx.quadraticCurveTo(x, y, x - radius.tl, y);
				break;
			case "flat":
				ctx.lineTo(x, y);
				break;
			default:
				break;
		}
		ctx.closePath();
		if (fill) {
			ctx.fill();
		}
		if (stroke) {
			ctx.stroke();
		}
	}

	roundRect(ctx, x, y, width, height, radius, fill, stroke) {
		if (typeof stroke == 'undefined') {
			stroke = true;
		}
		if (typeof radius === 'undefined') {
			radius = 5;
		}
		if (typeof radius === 'number') {
			radius = { tl: radius, tr: radius, br: radius, bl: radius };
		} else {
			var defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
			for (var side in defaultRadius) {
				radius[side] = radius[side] || defaultRadius[side];
			}
		}
		ctx.beginPath();
		ctx.moveTo(x + radius.tl, y);
		ctx.lineTo(x + width - radius.tr, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
		ctx.lineTo(x + width, y + height - radius.br);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
		ctx.lineTo(x + radius.bl, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
		ctx.lineTo(x, y + radius.tl);
		ctx.quadraticCurveTo(x, y, x + radius.tl, y);
		ctx.closePath();
		if (fill) {
			ctx.fill();
		}
		if (stroke) {
			ctx.stroke();
		}
	}

	textUnderline(context, text, x, y, color, textSize, align) {

		//Get the width of the text
		var textWidth = context.measureText(text).width;

		//var to store the starting position of text (X-axis)
		var startX;

		//var to store the starting position of text (Y-axis)
		// I have tried to set the position of the underline according
		// to size of text. You can change as per your need
		var startY = y + (parseInt(textSize) / 15);

		//var to store the end position of text (X-axis)
		var endX;

		//var to store the end position of text (Y-axis)
		//It should be the same as start position vertically.
		var endY = startY;

		//To set the size line which is to be drawn as underline.
		//Its set as per the size of the text. Feel free to change as per need.
		var underlineHeight = parseInt(textSize) / 15;

		//Because of the above calculation we might get the value less
		//than 1 and then the underline will not be rendered. this is to make sure
		//there is some value for line width.
		if (underlineHeight < 1) {
			underlineHeight = 1;
		}

		context.beginPath();
		if (align == "center") {
			startX = x - (textWidth / 2);
			endX = x + (textWidth / 2);
		} else if (align == "right") {
			startX = x - textWidth;
			endX = x;
		} else {
			startX = x;
			endX = x + textWidth;
		}

		context.strokeStyle = color;
		context.lineWidth = underlineHeight;
		context.moveTo(startX, startY);
		context.lineTo(endX, endY);
		context.stroke();
	}

	/* 	drawTextUnderline(ctx, text, x, y) {
			//let metrics = measureText(ctx, text)
			let textMetrics = ctx.measureText(text);
			let metrics = {
				width: Math.floor(textMetrics.width),
				height: Math.floor(textMetrics.fontBoundingBoxAscent + textMetrics.fontBoundingBoxDescent),
				actualHeight: Math.floor(textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent)
			}
			let fontSize = Math.floor(metrics.actualHeight * 1.4) // 140% the height
			switch (ctx.textAlign) {
				case "center": x -= (metrics.width / 2); break
				case "right": x -= metrics.width; break
			}
			switch (ctx.textBaseline) {
				case "top": y += (fontSize); break
				case "middle": y += (fontSize / 2); break
			}
			ctx.save()
			ctx.beginPath()
			ctx.strokeStyle = ctx.fillStyle
			ctx.lineWidth = Math.ceil(fontSize * 0.08)
			ctx.moveTo(x, y)
			ctx.lineTo(x + metrics.width, y)
			ctx.stroke()
			ctx.restore()
		} */

	/* 	draw() {
			let width, height, isTransparent, foregroundColor, backgroundColor, size, font, text;
			width = this.currentOutputParameter.previewParameters.outerVideoResolutionX;
			height = 200;
			isTransparent = true;
			foregroundColor = 'black';
			backgroundColor = 'none';
			size = 150;
			font = 'Arial';
			text = 'Simple text';

			const cv = <HTMLCanvasElement>document.createElement("CANVAS");
			cv.height = height;
			cv.width = width;
			//const cv = <HTMLCanvasElement>document.getElementById('cv');
			const ctx = cv.getContext('2d');
			ctx.clearRect(0, 0, width, height);
			ctx.font = size + 'px' + ' ' + font;
			if (isTransparent) {
				ctx.clearRect(0, 0, width, height);
			} else {
				ctx.fillStyle = backgroundColor;
				ctx.fillRect(0, 0, width, height);
			}
			ctx.fillStyle = foregroundColor;
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';//baseline;
			ctx.save();
			ctx.translate(width / 2, height / 2);
			//ctx.rotate(this.angle * Math.PI / 180);
			ctx.fillText(text, 0, 0);
			ctx.restore();
			this.download(cv);
		} */

	download(cv: HTMLCanvasElement) {
		const dataURL = cv.toDataURL('image/png');
		let downloadHref = dataURL;
		//const url = window.URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.style.display = "none";
		a.href = downloadHref;
		a.download = 'name';
		document.body.appendChild(a);
		a.click();
		//window.URL.revokeObjectURL(url);
	}
}